let envs
export default envs = {

    //testnet colors
    // 'FIRST_COLOR' : "#ED3F54",
    // 'SECOND_COLOR' : "#202E38",
    // 'THIRD_COLOR' : "#fff",

    //livenet colors
    'FIRST_COLOR' : "#061B37",
    'SECOND_COLOR' : "#005484",
    'THIRD_COLOR' : "#fff",


    //change the horizon url based on test/live
    'HORIZON': 'https://horizon.kuknos.org',


    //change the network type based on test/live
    'NETWORK': 'live',


    //change the name based on test or live
    // 'NAME': 'Kuknos live',



    'NODES': [
      {
        "id": "kuknos3.ld",
        "name": "Kuknos 3",
        "host": "srv3.kuknos.org",
        "port": 8001,
        "publicKey": "GAVHLFIMGISBCQML5ZXF4EBECXLILS7TIGMLAGJDILZGUXFHSRYLWXCI",
        "img": "https://www.kuknos.ir/api/v0/anchors/img/yekta.png"
      },
      {
        "id": "kuknos1.ld",
        "name": "Kuknos 1",
        "host": "srv1.kuknos.org",
        "port": 31625,
        "publicKey": "GAFSEMGGX6QCEF4U3LMQJEWXZTYFGIIZ3D452BQ5LV2TFCK7V3WGTJGI",
        "img": "https://www.kuknos.ir/api/v0/anchors/img/yekta.png"
      },
      {
        "id": "kuknos2.ld",
        "name": "Kuknos 2",
        "host": "srv2.kuknos.org",
        "port": 31625,
        "publicKey": "GBQEMHYNZ7ZMDJHDXARK36XW3XJ7XGIWDW47KNHQ7MWAKKJBZS7ZF5L6",
        "img": "https://www.kuknos.ir/api/v0/anchors/img/yekta.png"
      },
      {
        "id": "fanap1.ld",
        "name": "Fanap 1",
        "host": "188.75.112.10",
        "port": 24257,
        "publicKey": "GAJS24I53PDPEFNUCVB74KOUZIP2MIE2XQOMI3QUEN6GRVXETB3BDKMU",
        "img": "https://www.kuknos.ir/api/v0/anchors/img/fanap.png"
      },
      {
        "id": "fanap2.ld",
        "name": "Fanap 2",
        "host": "188.75.112.11",
        "port": 24257,
        "publicKey": "GAWQ3WYONL3UG5OTNBC2NZKI7M7W65NXICGNKVKPRT2PPLNQDJY6JZY2",
        "img": "https://www.kuknos.ir/api/v0/anchors/img/fanap.png"
      },
      {
        "id": "fanap3.ld",
        "name": "Fanap 3",
        "host": "188.75.112.12",
        "port": 24257,
        "publicKey": "GBZQ6NH4ANYQSGPSTR7TGEEKD645PWAZTQ5WLQ2LPF6ZJEZGDB4KRO52",
        "img": "https://www.kuknos.ir/api/v0/anchors/img/fanap.png"
      },
      {
        "id": "mellat1.ld",
        "name": "Mellat 1",
        "host": "185.227.136.16",
        "port": 11625,
        "publicKey": "GD3CEJ6QEZK7CSFPZLDGMU54S5JBAGLBCPFQBSGGMONDNH7XM7XUFMPM",
        "img": "https://www.kuknos.ir/api/v0/anchors/img/behsazan.png"
      },
      {
        "id": "mellat2.ld",
        "name": "Mellat 2",
        "host": "94.182.210.82",
        "port": 11625,
        "publicKey": "GCJLBMVFEYE24D6A7IFU3K73TQ7SMGO6JJE3BKF2XENFWLAQ6EIT2VSA",
        "img": "https://www.kuknos.ir/api/v0/anchors/img/behsazan.png"
      },
      {
        "id": "mellat3.ld",
        "name": "Mellat 3",
        "host": "94.182.210.83",
        "port": 11625,
        "publicKey": "GCC4UCD5VD43IBGJ2JWZJVNHWLUFCS2YPACNBGLIPOWF3UB2CSSGDPHZ",
        "img": "https://www.kuknos.ir/api/v0/anchors/img/behsazan.png"
      },
      {
        "id": "parsian1.ld",
        "name": "Parsian 1",
        "host": "178.21.47.229",
        "port": 11251,
        "publicKey": "GA2PQLMBZCSDA7RWLMLR2G4GJVBXSZY3UABUYFYLR3OFFTTL5KXCA5M3",
        "img": "https://www.kuknos.ir/api/v0/anchors/img/parsian.png"
      },
      {
        "id": "parsian2.ld",
        "name": "Parsian 2",
        "host": "178.21.47.229",
        "port": 11252,
        "publicKey": "GCVJUG7MBW5Q72IDQSRY2NFGPFM47L2ZHMV5QZJSVFCW6LSN5J755MYT",
        "img": "https://www.kuknos.ir/api/v0/anchors/img/parsian.png"
      },
      {
        "id": "parsian3.ld",
        "name": "Parsian 3",
        "host": "178.21.47.229",
        "port": 11253,
        "publicKey": "GBTYL7SPHDQD4FKFLF7WIQKRQH6FNFKAACDRTHGZAAO5CMAD4PL35ZOL",
        "img": "https://www.kuknos.ir/api/v0/anchors/img/parsian.png"
      },
      {
        "id": "tosan1.ld",
        "name": "Tosan 1",
        "host": "srv1.tosan-kuknos.com",
        "port": 31625,
        "publicKey": "GDXUQNO6TDNQMOVR22B47W6CGNU34TUDWASLRQLY4HEFMLAT6GVWZKM3",
        "img": "https://www.kuknos.ir/api/v0/anchors/img/tecvest.png"
      },
      {
        "id": "tosan2.ld",
        "name": "Tosan 2",
        "host": "srv2.tosan-kuknos.com",
        "port": 31625,
        "publicKey": "GAHBWDGVZ6YK2XD45V6NOQ7S54HUKZBCS2ZOKFDH27FJZWN4V33O6HPJ",
        "img": "https://www.kuknos.ir/api/v0/anchors/img/tecvest.png"
      },
      {
        "id": "tosan3.ld",
        "name": "Tosan 3",
        "host": "srv3.tosan-kuknos.com",
        "port": 17201,
        "publicKey": "GDU7OORIOMUK4QEUIUCHOUTIYSYVF25HL52RG4PW3OHJ2GJGD2KSIFHQ",
        "img": "https://www.kuknos.ir/api/v0/anchors/img/tecvest.png"
      },
      {
        "id": "sadad1.ld",
        "name": "Sadad 1",
        "host": "185.135.30.252",
        "port": 11625,
        "publicKey": "GCLUNM3O5NOTUBUJPA2TSWCMDUKZ3YYUL5ZZC7WRX4VWPYAOXZJEZZJT",
        "img": "https://www.kuknos.ir/api/v0/anchors/img/sadad.png"
      },
      {
        "id": "sadad2.ld",
        "name": "Sadad 2",
        "host": "185.135.30.252",
        "port": 11627,
        "publicKey": "GD6KUTWXCKYYNWFSSUYLB7KZWSTA23P6A7FMQE6CBWCNZXE4IN2MG6E2",
        "img": "https://www.kuknos.ir/api/v0/anchors/img/sadad.png"
      },
      {
        "id": "sadad3.ld",
        "name": "Sadad 3",
        "host": "185.135.30.252",
        "port": 11629,
        "publicKey": "GA3R67F33JMYAID52Y5DPH6YOAE6MEI5OINTCV2HRSHFBUJZAPI6XDB7",
        "img": "https://www.kuknos.ir/api/v0/anchors/img/sadad.png"
      },
      



      {
          "id": "kuknos1.ld-test",
          "name": "Kuknos 1",
          "host": "195.248.241.249",
          "port": 12625,
          "publicKey": "GASES2LBCKRQPGLU4MYQT7YYZZESE3GPGWOHOTBGZHUXAVLTH44WBM2J",
          "img": "https://www.kuknos.ir/api/v0/anchors/img/yekta.png"
        },
        {
          "id": "kuknos2.ld-test",
          "name": "Kuknos 2",
          "host": "45.82.136.19",
          "port": 12625,
          "publicKey": "GCO7Q2UOKTXLHMWWROC7GUMW4PDJVHP4PYTLRIGCZW3FKW6TBA7FEVO6",
          "img": "https://www.kuknos.ir/api/v0/anchors/img/yekta.png"
        },
        {
          "id": "kuknos3.ld-test",
          "name": "Kuknos 3",
          "host": "212.80.25.153",
          "port": 8037,
          "publicKey": "GC3GLVWGG7QDYLB6ZWQWKJ4NM5M675JNQ42BUDOY5FMKBQDVJWLCVQSZ",
          "img": "https://www.kuknos.ir/api/v0/anchors/img/yekta.png"
        },
        {
          "id": "mellat1.ld-test",
          "name": "Mellat 1",
          "host": "88.198.229.253",
          "port": 11625,
          "publicKey": "GCS7PR6MEPPPG2XASW6G46X2YEE6QNBKZWH46DCLRZH3K3AWLWGQME2U",
          "img": "https://www.kuknos.ir/api/v0/anchors/img/behsazan.png"
        },
        {
          "id": "mellat2.ld-test",
          "name": "Mellat 2",
          "host": "185.88.152.219",
          "port": 11625,
          "publicKey": "GCPK5RCNFGKKY5EATY7IYKXBBOA5FJIXSULO7AMHPD2GQ6YXPEGDOSLF",
          "img": "https://www.kuknos.ir/api/v0/anchors/img/behsazan.png"
        },
        {
          "id": "parsian1.ld-test",
          "name": "Parsian 1",
          "host": "178.21.47.229",
          "port": 12350,
          "publicKey": "GBLRVCYGY4F2JAMOWHUHNFGIRLRQAM2AYWM6PO23QWZVDJWTEMZYXR6X",
          "img": "https://www.kuknos.ir/api/v0/anchors/img/parsian.png"
        },
        {
          "id": "parsian2.ld-test",
          "name": "Parsian 2",
          "host": "178.21.47.229",
          "port": 12351,
          "publicKey": "GCU7HEVUTN6LWSQW5VIOT3CH3UXH3OUDQEGNUQJG5YAYBN6CFYB7DQJT",
          "img": "https://www.kuknos.ir/api/v0/anchors/img/parsian.png"
        },
        {
          "id": "parsian3.ld-test",
          "name": "Parsian 3",
          "host": "178.21.47.226",
          "port": 5557,
          "publicKey": "GAZKG43WFKL4G5ECO3YV7KZG56V6K73LMOFWDSIYCNOX3BNX2EZYCBRZ",
          "img": "https://www.kuknos.ir/api/v0/anchors/img/parsian.png"
        },
        {
          "id": "sadad1.ld-test",
          "name": "Sadad 1",
          "host": "185.135.30.251",
          "port": 11625,
          "publicKey": "GC5KYYOO32FKUYWHHPHJHTCOKJLPTB6FVO6KEB6SE2XZPUNT7DOL33HR",
          "img": "https://www.kuknos.ir/api/v0/anchors/img/sadad.png"
        },
        {
          "id": "sadad2.ld-test",
          "name": "Sadad 2",
          "host": "185.135.30.251",
          "port": 11627,
          "publicKey": "GBX42BJVL4H3CLYRXWFE2HJX2CCCT4XCLNKAIV5TEEPCZLFFNQR64FOH",
          "img": "https://www.kuknos.ir/api/v0/anchors/img/sadad.png"
        },
        {
          "id": "sadad3.ld-test",
          "name": "Sadad 3",
          "host": "185.135.30.251",
          "port": 11629,
          "publicKey": "GDMH6B5SHOKABCC4YHVLGIEJZEOIUKBXGX33CSZZGCEY4YHDNA3KNAMB",
          "img": "https://www.kuknos.ir/api/v0/anchors/img/sadad.png"
        },
        {
          "id": "fanap1.ld-test",
          "name": "Fanap 1",
          "host": "188.75.112.14",
          "port": 24257,
          "publicKey": "GCK3ZRARLDKHERZCJ76W7EYUZQPCXCR2DLTIGVSIYBQI5Q3JUNJW6OEL",
          "img": "https://www.kuknos.ir/api/v0/anchors/img/fanap.png"
        },
        {
          "id": "fanap2.ld-test",
          "name": "Fanap 2",
          "host": "188.75.112.14",
          "port": 25257,
          "publicKey": "GCP6V5YH6TAAJVT6GSI6BM5UGR3BKP6ZKPC3JQYXSMEV4RGFTDJUWGOU",
          "img": "https://www.kuknos.ir/api/v0/anchors/img/fanap.png"
        },
        {
          "id": "fanap3.ld-test",
          "name": "Fanap 3",
          "host": "188.75.112.13",
          "port": 24257,
          "publicKey": "GDEB2PWDC7T26SG7QKO5674GR4GLP6XVOJSJMDUULALLI6BPIP3XAVUK",
          "img": "https://www.kuknos.ir/api/v0/anchors/img/fanap.png"
        },
        {
          "id": "tosan1.ld-test",
          "name": "Tosan 1",
          "host": "srv1.tosan-kuknos.com",
          "port": 17201,
          "publicKey": "GCLO6MXYYKKTUSUJOJYCBH2PDRBZUDEPHKZTP4AH23QPWCKXKW6WXBNH",
          "img": "https://www.kuknos.ir/api/v0/anchors/img/tecvest.png"
        },
        {
          "id": "tosan2.ld-test",
          "name": "Tosan 2",
          "host": "srv2.tosan-kuknos.com",
          "port": 18202,
          "publicKey": "GAMCGBS4TY2YP7XE372SR4QBR7PROVSWKPCKHH34TYPBCFRSDGTP22US",
          "img": "https://www.kuknos.ir/api/v0/anchors/img/tecvest.png"
        },
        {
          "id": "tosan3.ld-test",
          "name": "Tosan 3",
          "host": "srv3.tosan-kuknos.com",
          "port": 17202,
          "publicKey": "GCRJG3IGADFELFJAV2UHJRHIGRSKUYCEKHJPBUO3IMMQGMDJMC3JDC7T",
          "img": "https://www.kuknos.ir/api/v0/anchors/img/tecvest.png"
        },
        {
          "id": "tejarat1.ld-test",
          "name": "Tejarat 1",
          "host": "185.141.171.51",
          "port": 11625,
          "publicKey": "GC6EWNIWBVB7MUPEIASZQ73KFYRPYRV6YBE7JGCIVF6UEC3VJ65XUMEP",
          "img": "https://www.kuknos.org/wp-content/uploads/2020/01/bazargangostar_1_1.png"
        },
        {
          "id": "tejarat2.ld-test",
          "name": "Tejarat 2",
          "host": "185.141.171.51",
          "port": 11627,
          "publicKey": "GD2Q55EUXT5QBKX6ESKSMJKVEHRMTHUUWLGDCV5MHNVZ4OJU3HIYFK2B",
          "img": "https://www.kuknos.org/wp-content/uploads/2020/01/bazargangostar_1_1.png"
        },
        {
          "id": "tejarat3.ld-test",
          "name": "Tejarat 3",
          "host": "185.141.171.59",
          "port": 11625,
          "publicKey": "GBW5HC5S2J72EKK4QLS73SGF4HPREY372246GHLF2VY3UOV5G4RFJ7GZ",
          "img": "https://www.kuknos.org/wp-content/uploads/2020/01/bazargangostar_1_1.png"
        },
    ]
}



// WEBPACK FOOTER //
// ./frontend/env.js